//This file contains and import all components required by REACT-PDF library in order to generate project printable report.
import React, { Component } from "react";

//React-PDF dependencies
import { Page, Text, View, Document, Image, StyleSheet, Font } from "@react-pdf/renderer";

// Lodash
import _ from 'lodash';

// React-Pdf custom components
import ProjectLogEntryPDF from "./innerComponents/pdfComponents/ProjectLogEntryPdf";
import PdfIcon from "./innerComponents/pdfComponents/PdfIcon";
import SmokeTestPdf from "./innerComponents/pdfComponents/SmokeTestPdf";
import PRChecklistPdf from "./innerComponents/pdfComponents/PRChecklistPdf";

import HeaderLogo from '../assets/lexia_logo_pdf_header_220x78.png';

// In order to register to generate pdf file with custom fonts.
Font.register({ family: 'Roboto', format: 'truetype', src: '//fonts.gstatic.com/s/roboto/v16/zN7GBFwfMP4uA6AR0HCoLQ.ttf' });

// Create styles
const styles = StyleSheet.create({
  body: {
    paddingTop: 30,
    paddingBottom: 30,
    paddingHorizontal: 50,
  },
  title: {
    // padding: 0,
    position: 'relative',
    titleText: {
      fontSize: 20,
      opacity: 0.8,
      color: 'black',
      display: 'block',
      textAlign: 'left',
      fontFamily: 'Roboto',
    },
  },
  image: {
    marginRight: 5,
    maxWidth: 135.3,
    maxHeight: 51.1,
    paddingTop: 8,
    left: -10
  },
  header: {
    fontSize: 14,
    color: '#303e84',
    left: -10,
    fontWeight: 600,
    marginBottom: 15,
    textAlign: 'left',
    height: 30,
    paddingTop: 8,
  },
  footer: {
    position: 'absolute',
    fontSize: 10,
    bottom: 15,
    left: 30,
    right: 0,
    textAlign: 'center',
    color: '#000000',
    opacity: 0.8,
    fontFamily: 'Roboto',
  },
  projectBasicInfoPdf: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginBottom: 10,
    column: {
      display: 'flex',
      flexDirection: 'row',
    },
  },
  normalField: {
    display: 'inline-flex',
    flexDirection: 'column',
    fontSize: 16,
    width: 236,
    height: 40,
    position: 'relative',
    label: {
      fontSize: 10,
      color: '#000000',
      opacity: 0.3,
      paddingTop: 16,
      fontFamily: 'Roboto',
    },
    input: {
      fontSize: 12,
      fontFamily: 'Roboto',
    },
  },
  card: {
    display: "flex",
    flexDirection: "column",
    margin: '8 0',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: "#d9d9d9",
    width: "100%",
    title: {
      top: 15,
      fontSize: 13,
      fontWeight: 900,
      fontFamily: 'Roboto',
    },
    primaryIcon: {
      alignItems: 'center',
      justifyContent: 'center',
      width: 30,
      height: 30,
      margin: 7,
      backgroundColor: process.env.REACT_APP_PRIMARY_COLOR,
      borderRadius: 40,
      icon:{
        width: 18,
      },
    },
    secondaryIcon: {
      margin: '5 10',
      alignItems: 'center',
      justifyContent: 'center',
      width: 25,
      height: 25,
      backgroundColor: "#ec407a",
      borderRadius: 40,
      icon:{
        width: 14,
      },
    },
    column: {
      display: 'flex',
      flexDirection: 'row',
    },
    row: {
      display: 'flex',
      flexDirection: 'column',
    },
    label: {
      margin: 10,
      fontSize: 12,
      background: '#000000',
      opacity: 0.4,
      fontFamily: 'Roboto',
    }
  },
  avatarItem: {

    display: 'flex',
    flexDirection: 'row',
    left: 15,

    disable: {
      display: 'flex',
      flexDirection: 'row',
      backgroundColor: "gray",
    },
    enable: {
      display: 'flex',
      flexDirection: 'row',
      backgroundColor: "blue",
    },

    label: {
      top: 9,
      fontSize: 12,
      fontFamily: 'Roboto',
    },
  },
});

const ProjectBasicInfoPdf = ({ children, ...props }) => (

  <View style={styles.projectBasicInfoPdf}>
    <View style={styles.projectBasicInfoPdf.column}>
      <NormalField label={"Project Number"}> {props.current_project.id.toString()} </NormalField>
    </View>
    <View style={styles.projectBasicInfoPdf.column}>
      <NormalField label={"Start Date"}> { new Date(Date.parse(props.current_project.startDate)).toDateString() } </NormalField>
      <NormalField label={"End Date"}> { new Date(Date.parse(props.current_project.endDate)).toDateString() } </NormalField>
    </View>
    <View style={styles.projectBasicInfoPdf.column}>
      <NormalField label={"Site Name"}> {props.current_project.siteName.toString()} </NormalField>
      <NormalField label={"Site Address"}> {props.current_project.siteAddress.toString()} </NormalField>
    </View>
    <View style={styles.projectBasicInfoPdf.column}>
      <NormalField label={"Location"}> {props.current_project.location.toString()} </NormalField>
      <NormalField label={"Region"}> {props.current_project.region.name.toString()} </NormalField>
    </View>
    <View style={styles.projectBasicInfoPdf.column}>
      <NormalField label={"Created By"}> {props.current_project.creator ?  props.current_project.creator.fullName : "No data"} </NormalField>
      <NormalField label={"Created Date"}> {new Date(Date.parse(props.current_project.insertedAt)).toLocaleTimeString() + " - " +new Date(Date.parse(props.current_project.insertedAt)).toLocaleDateString()} </NormalField>
    </View>
  </View>
);

const NormalField = ({ children, ...props }) => (
  <View style={styles.normalField}>
    <Text style={styles.normalField.label} {...props}>
      {props.label}
    </Text>
    <Text style={styles.normalField.input} {...props}>
      {children}
    </Text>
  </View>
);

const BasicInfoCardPanel = ({ children, ...props }) => (
  <View style={styles.card}>
    <View style={styles.card.column}>
      <PdfIcon
        src={props.iconUrl}
        style={styles.card.primaryIcon}
      />
      <Text style={styles.card.title}>
        {children}
      </Text>
    </View>
    { props.type === "user" ? _getSupervisorsList(props.current_project) : _getEnclosuresList(props.current_project)}
  </View>
);

const AvatarItem = ({ children, ...props }) => (
  <View style={styles.avatarItem}>
      <PdfIcon
        src={props.src}
        style={props.style}
      />
      <Text style={styles.avatarItem.label}>{children}</Text>
  </View>
);

function _getSupervisorsList(current_project) {
  return current_project.projectInvitations !== null && current_project.projectInvitations.length > 0 ?
    current_project.projectInvitations.map((pi, id) =>
      <AvatarItem
        object={pi.user} type="user" key={id}
        src="https://img.icons8.com/metro/100/ffcc80/contacts.png"
        style={styles.card.secondaryIcon}
      >
        {pi.user.fullName}
      </AvatarItem>
    ) : <Text style = {styles.card.label}>There are no Supervisors yet!</Text>;
}

function _getEnclosuresList(current_project) {
  return current_project.enclosures !== null && current_project.enclosures.length > 0 ?
    current_project.enclosures.map((enclosure, id) =>
      <AvatarItem object={enclosure} type="enclosure" key={id}
        src="https://img.icons8.com/material/100/ffcc80/folder-invoices--v1.png"
        style={styles.card.secondaryIcon}
      >
        {enclosure.name}
      </AvatarItem>
    ) : <Text style = {styles.card.label} >There are no Enclosures yet!</Text>;
}

function _getProjectLogEntries(current_project, date, data) {
  const plesFiltered = date.activeFilter ? current_project.projectLogEntries.filter(entry => (new Date(entry.date) > new Date(date.startDate)) && (new Date(entry.date) < new Date(date.endDate)))
                        : current_project.projectLogEntries;
  const plesSorted = _.orderBy(plesFiltered, ['date'], ['desc']);
  if (plesFiltered === null || plesFiltered.length <= 0) return <Text style = {styles.card.label}>There are no Project Log Entries for that dates</Text>;
  return current_project.projectLogEntries !== null && current_project.projectLogEntries.length > 0 ?
    plesSorted.map((ple, id) =>
      <ProjectLogEntryPDF ple={ple} key={id} current_project={current_project} data={data}/>
    ) : <Text style = {styles.card.label}>There are no Project Log Entries yet!</Text>;
}

function _getPRCList(current_project, data) {
  const prcsSorted = _.orderBy(current_project.postRemediationChecklists, ['date'], ['desc']);
  return prcsSorted !== null && current_project.postRemediationChecklists.length > 0 ?
    prcsSorted.map((prc, id) =>
      <PRChecklistPdf prc={prc} key={id} data={data}/>
    ) : <Text style = {styles.card.label}>There are no PRCs yet!</Text>;
}

function _getSmokeTestsList(current_project) {
  return current_project.smokeTests !== null && current_project.smokeTests.length > 0 ?
    current_project.smokeTests.map((smokeTest, id) =>
      <SmokeTestPdf smokeTest={smokeTest} key={id}/>
    ) : <Text style = {styles.card.label}>There are no SmokeTests yet!</Text>;
}

class ProjectPdf extends Component {

  render() {

    const { sections, date, data, current_project } = this.props;

    return (
      <Document>
        <Page style={styles.body} size="A4" wrap>
          <Image src={HeaderLogo} style={styles.image}/>
          <Text style={styles.header} >
            Sitepacks
          </Text>

          <View style={styles.title}>
            <Text style={styles.title.titleText}> { current_project.name } </Text>
          </View>

          { sections.showBasicInfoSection ?
            <View>
              <ProjectBasicInfoPdf current_project={current_project}></ProjectBasicInfoPdf>
            </View> : null
          }

          <BasicInfoCardPanel
            current_project = {current_project}
            iconUrl = "https://img.icons8.com/ios-filled/100/FFFFFF/conference-call.png"
            type = "user"
          >
            Supervisors
          </BasicInfoCardPanel>

          <BasicInfoCardPanel
            current_project = {current_project}
            iconUrl = "https://img.icons8.com/material-sharp/100/FFFFFF/thumbnails.png"
            type = "enclosure"
          >
            Enclosures
          </BasicInfoCardPanel>

          { sections.showProjectLogSection ?
            <View break>
              <View style={styles.title}>
                <Text style={styles.title.titleText}> Project log </Text>
              </View>
              { _getProjectLogEntries(current_project, date, data) }
            </View> : null
          }

          { sections.showPRCSection ?
            <View break>
              <View style={styles.title} >
                <Text style={styles.title.titleText}> Post Remediation Checklists </Text>
              </View>
              { _getPRCList(current_project, data) }
            </View> : null
          }

          <Text
            style={styles.footer}
            render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
            fixed
          />

          {/* This code is made because a break (break-line) REACT-PDF library bug.(don't allow break in a new page with little text) */}
          { sections.showSmokeTestSection ? <Text></Text> : <View></View> }
          {/* */}

        </Page>

        { sections.showSmokeTestSection ?
          <Page style={styles.body} size="A4" wrap>
            <View style={styles.title}>
              <Text style={styles.title.titleText} > Smoke Tests </Text>
            </View>

            { _getSmokeTestsList(current_project) }

            <Text
            style={styles.footer}
            render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
            fixed
            />
          </Page> : <Page></Page>
        }
      </Document>
    );
  }
}

export default ProjectPdf;



// WEBPACK FOOTER //
// src/components/ProjectPdf.js